import { SubCategoryRepository } from '../../domain/repositories/sub-category.repository';

export class DeleteSubCategoryUseCase {
  constructor(private readonly subCategoryRepository: SubCategoryRepository) {}

  async execute(id: string): Promise<void> {
    return this.subCategoryRepository.deleteSubCategory(id);
  }
}
